import axios from 'axios'
import { SessionKeys, startSession } from '../utils/AppUtils'

import CONFIG from '../utils/config'
import API_LIST from '../utils/apiList'
import { objectToFormData } from './data'
import _ from 'lodash'

export const login = async (payload) => {
  // console.log(payload)
  let formData = objectToFormData(payload)
  let isJSON = false;
  let isAdminBroker = false;
  let isHostBroker = false;
  let url = CONFIG.API_URL + API_LIST.API_ROUTES.LOGIN;

  if (payload.action === 'realtor_login') {
    url = CONFIG.API_URL_BROKER_ADMIN + API_LIST.API_ROUTES_BROKER.LOGIN_BASE_PATH
    delete payload.action;
    formData = payload
    isJSON = true
    isAdminBroker = true
    // console.log('formData', formData)
  } else if (payload.action === 'realtor_login_google') {
    url = CONFIG.API_URL_BROKER_ADMIN + API_LIST.API_ROUTES_BROKER.LOGIN_BASE_PATH_GOOGLE
    delete payload.action;
    formData = payload
    isJSON = true
    isAdminBroker = true
  } else if (payload.action === 'realtor_login_from_php') {
    url = CONFIG.API_URL_BROKER_ADMIN + API_LIST.API_ROUTES_BROKER.LOGIN_BASE_PATH_SSO
    delete payload.action;
    formData = payload
    isJSON = true
    isAdminBroker = true
  }
  else if (payload.action === 'hostinst_login') {
    url = CONFIG.API_URL_BROKER_ADMIN + API_LIST.API_ROUTES_BROKER.LOGIN_HOSTINST_BASE_PATH
    delete payload.action;
    formData = payload
    isJSON = true
    isHostBroker = true
    // console.log('formData', formData)
  }

  return axios({
    method: "post",
    url,
    data: formData,
    headers: isJSON ? { "Content-Type": "application/json" } : { "Content-Type": "multipart/form-data" },
  }).then(response => {
    // console.log('login: ',response)
    if (response.data.status) {
      let configValue = response?.data?.data?.config;
      localStorage.setItem(SessionKeys.NOTI_SHOW, true)
      // localStorage.setItem(SessionKeys.API_TOKEN, response.data.apiToken)
      // localStorage.setItem(SessionKeys.IS_PREMIUM, response.data.data.isPremium)
      // localStorage.setItem(SessionKeys.EMAIL_SESSION, response.data.data.email)
      // localStorage.setItem(SessionKeys.BROKER_ID, response.data.data.broker_id) // IT WILL BE DYNAMIC
      localStorage.setItem(SessionKeys.COMPANY_ID,response?.data?.data?.company_id)
      localStorage.setItem(SessionKeys.API_TOKEN_BROKER, response?.data?.token)
      // localStorage.setItem(SessionKeys.IS_AGGREED, true) //response.data.data.isagreed
      // localStorage.setItem(SessionKeys.USER_ID, response.data.data.user_id)
      // localStorage.setItem(SessionKeys.BROKER_NAME, response.data.data.broker_name)
      // sessionStorage.setItem(SessionKeys.COMPLETE_TOUR, response.data.data.complete_tour)
      // localStorage.setItem(SessionKeys.FIRST_NAME, response.data.data.firstname)
      // localStorage.setItem(SessionKeys.LAST_NAME, response.data.data.lastname)
      // localStorage.setItem(SessionKeys.SSO_ENABLED, response.data.data.is_sso_enabled)
      isHostBroker && localStorage.setItem(SessionKeys.HOSTINST_ID, response.data.data.user_id)
      let apiToken = isAdminBroker ? response?.data?.token : response?.data?.apiToken;
      // localStorage.setItem(SessionKeys.API_TOKEN, response.data.apiToken)
      // localStorage.setItem(SessionKeys.EMAIL_SESSION, response.data.data.email)
      //Setting default language to english
      // localStorage.setItem(SessionKeys.SELECTED_LANGUAGE, 1)
      // localStorage.setItem(SessionKeys.NEW_AI_ROLEPLAY_TOKEN,response.data.data.new_ai_roleplay_token);


      //config value of show-hide features
      if (!_.isEmpty(configValue)) {
        // localStorage.setItem(SessionKeys.SHOW_ROLEPLAY, configValue.roleplay)
        // localStorage.setItem(SessionKeys.SHOW_DISCUSS_TAB, configValue.discuss_tab ? configValue.discuss_tab : "false")
        // localStorage.setItem(SessionKeys.SHOW_MY_WALL, configValue.wall)
        // localStorage.setItem(SessionKeys.SHOW_OFFICE_NAME, configValue.office_name)
        // localStorage.setItem(SessionKeys.SHOW_LEADERBOARD, configValue.leaderboard_or_point)
        // localStorage.setItem(SessionKeys.SHOW_MENTER_COACH, configValue.mentor_coach_teamlead)
      } else {
        // localStorage.setItem(SessionKeys.SHOW_DISCUSS_TAB, "false")
      }

      startSession();

      return {
        status: 'success',
        payload: {
          user: response.data.data,
          apiToken: apiToken,
          message: response.data.message
        }
      }
    } else {
      return {
        status: 'error',
        error: {
          message: response.data.message
        }
      }
    }
  }).catch((error) => {
    return {
      status: 'error',
      error
    }
  })
}

export const logout = async (payload) => {
  // console.log(payload)

  let url = `${CONFIG.API_URL}${API_LIST.API_ROUTES.BASE_PATH}?token=${payload.token}&module=${payload.module}`;
  if (payload.action && payload.action === 'realtor_logout') {
    url = CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.AJAX_BASE_PATH;
  }
  return axios({
    method: "get",
    url,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    // console.log(response)
    if (response.data.status) {
      // localStorage.setItem(SessionKeys.API_TOKEN, response.data.apiToken)
      return {
        status: 'success',
        payload: {
          message: response.data.message
        }
      }
    } else {
      return {
        status: 'error',
        error: {
          message: response.data.message
        }
      }
    }
  }).catch((error) => {
    return {
      status: 'error',
      error
    }
  })
}